import { QuotationDetailPrintModel } from "./quotation-detail-print.model";

export class QuotationPrintModel {
  quotationId: number = 0;
  enterpriseLogo: string | null = null;
  enterpriseNit: string = '';
  enterpriseName: string = '';
  branchName: string = '';
  consecutive: string = '';
  consecutiveVersion: number = 0;
  branchAddress: string = '';
  branchPhone: string = '';
  dateQuotation: Date = new Date();
  quotationType: string = '';
  nameClient: string = '';
  nameConstructionSite: string = '';
  contact: string = '';
  phones: string = '';
  addressConstructionSite: string = '';
  mountingValue: number = 0;
  observation: string = '';
  email: string = '';
  branchQuotationObservation: string = '';
  enterpriseParticularCondition: string = '';
  swConditions: boolean = true
  sellerName: string = '';
  sellerPosition: string = '';
  sellerAddress: string = '';
  sellerPhones: string = '';
  sellerEmail: string = '';
  totalSubtotalValue: number = 0;
  totalValue: number = 0;
  totalIvaValue: number = 0;
  totalWithIvaValue: number = 0;
  totalWeight: number = 0;
  totalReplacementValue: number = 0;
  quotationDetails: QuotationDetailPrintModel[] = [];

}